<template>
    <div>
<!--        {{style_selected1_name}}-->
        <table>
            <tr v-if="
            style_selected1_name==='クッション4サイドデコ' ||
            style_selected1_name==='クッション2サイドデコ' ||
            style_selected1_name==='クッション2サイドボーダーデコ付き'
            ">
                <td>フリンジ品番を選ぶ</td>
                <td>
                    <b-form-select v-model="fringe_selected"
                                   :options="$store.state.xlsx_select_data.select_data[$store.state.xlsx_data.style_data[$store.state.step2_data.style_selected1_id].group1][$store.state.step2_data.style_selected1_name]['フリンジ品番を選ぶ'].option"></b-form-select>
                </td>
            </tr>
            <tr>
                <td>仕上りサイズを選択する</td>
                <td>
                    <b-form-select v-model="select_size"
                                   :options="$store.state.xlsx_select_data.select_data[$store.state.xlsx_data.style_data[$store.state.step2_data.style_selected1_id].group1][$store.state.step2_data.style_selected1_name]['仕上りサイズを選択する'].option"></b-form-select>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "cushion",
        created: function () {
            if(this.fringe_selected === '' &&
                this.$store.state.step2_data.style_selected1_name==='クッション4サイドデコ' ||
                this.$store.state.step2_data.style_selected1_name==='クッション2サイドデコ' ||
                this.$store.state.step2_data.style_selected1_name==='クッション2サイドボーダーデコ付き'){
                this.fringe_selected = this.$store.state.xlsx_select_data.select_data[this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1][this.$store.state.step2_data.style_selected1_name]['フリンジ品番を選ぶ'].option[0].value
            }
            if(this.select_size === ''){
                this.select_size = this.$store.state.xlsx_select_data.select_data[this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1][this.$store.state.step2_data.style_selected1_name]['仕上りサイズを選択する'].option[0].value
            }
        },
        watch: {
            style_selected1_name: function (value) {
                if(this.fringe_selected === '' &&
                    this.$store.state.step2_data.style_selected1_name==='クッション4サイドデコ' ||
                    this.$store.state.step2_data.style_selected1_name==='クッション2サイドデコ' ||
                    this.$store.state.step2_data.style_selected1_name==='クッション2サイドボーダーデコ付き'){
                    this.fringe_selected = this.$store.state.xlsx_select_data.select_data[this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1][this.$store.state.step2_data.style_selected1_name]['フリンジ品番を選ぶ'].option[0].value
                }
                if(this.select_size === ''){
                    this.select_size = this.$store.state.xlsx_select_data.select_data[this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1][this.$store.state.step2_data.style_selected1_name]['仕上りサイズを選択する'].option[0].value
                }
            },
        },
        computed: {
            fringe_selected: {
                get: function () {
                    return this.$store.state.step3_data.fringe
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'fringe', value:value})
                    this.select_size = this.$store.state.step3_data.select_size
                }
            },
            select_size: {
                get: function () {
                    return this.$store.state.step3_data.select_size
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'select_size', value:value})
                    const style_selected1_name = this.$store.state.step2_data.style_selected1_name
                    const fringe = this.$store.state.step3_data.fringe
                    let width_size = 0
                    let wid = 0
                    let hid = 0
                    //45×45cm	43×43cm	30×30cm	60×60cm	45×25cm
                    //45×45cm	43×43cm    30×30cm	60×60cm	45×25cm（中材付き）
                    //0?10,11?20,21?30,31?40,41?50
                    switch (value) {
                        case '45×45cm' :
                            wid = 1
                            break
//                       case '43×43cm' :
//                           wid = 2
//                            break
                        case '30×30cm' :
                            wid = 2
                            break
                        case '60×60cm' :
                            wid = 3
                            break
                        case '45×25cm（中材付き）' :
                            wid = 4
                            break
                        default :
                            break
                    }
                    if(style_selected1_name==='クッションプレーン'){
                        hid = 1
                    }else if(style_selected1_name==='クッションプレーン（Rカット)'){
                        hid = 2
//                   }else if(style_selected1_name==='クッション額縁'){
//                       hid = 3
                    }else if(style_selected1_name==='クッションパイピング'){
                        hid = 3
                    }else if(style_selected1_name==='クッション4サイドデコ'){
                        switch (fringe) {
                            case 'PV5010～5017' :
                                hid = 4
                                break
                            case 'PV5021・5022' :
                                hid = 5
                                break
//                           case 'PV5061～5063' :
//                               hid = 7
//                                break
                            default :
                                break
                        }
                    }else if(style_selected1_name==='クッション2サイドデコ'){
                        switch (fringe) {
                            case 'PV5001' :
                                hid = 6
                                break
                            case 'PV5002' :
                                hid = 7
                                break
                            case 'PV5003' :
                                hid = 8
                                break
                            case 'PV5004' :
                                hid = 9
                                break
                            case 'PV5005' :
                                hid = 10
                                break
                            case 'PV5006' :
                                hid = 11
                                break
                            case 'PV5031・5032' :
                                hid = 12
                                break
                            case 'PV5051～5055' :
                                hid = 13
                                break
                            default :
                                break
                        }
                    }else if(style_selected1_name==='クッションパイピング（2カラー）'){
                        hid = 14
                    }else if(style_selected1_name==='クッションボトムボーダー'){
                        hid = 15
                    }else if(style_selected1_name==='クッション2サイドボーダーデコ付き'){
                        switch (fringe) {
                            case 'PV5001' :
                                hid = 16
                                break
                            case 'PV5002' :
                                hid = 17
                                break
                            case 'PV5003' :
                                hid = 18
                                break
                            case 'PV5004' :
                                hid = 19
                                break
                            case 'PV5010～5017' :
                                hid = 20
                                break
                            case 'PV5021・5022' :
                                hid = 21
                                break
                            case 'PV5051～5055' :
                                hid = 22
                                break
                            case 'PV5061～5063' :
                                hid = 25
                                break
                            default :
                                break
                        }
                    }
                    if(value==='50×50×5cm（中材付き）'){
                        this.$store.commit('updateOptionSelected', {name:'width_size', value:50, no_check: true})
                        this.$store.commit('updateOptionSelected', {name:'height_size', value:50})
                    }else{
                        this.$store.commit('updateOptionSelected', {name:'width_size', value:50, no_check: true})
                        this.$store.commit('updateOptionSelected', {name:'height_size', value:50, no_check: true})
                        this.$store.commit('updateOptionSelected', {name:'wid', value:wid})
                        this.$store.commit('updateOptionSelected', {name:'hid', value:hid})
                    }
                }
            },
            group1_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected1_id !== ''){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                    }
                    return ''
                },
            },
            group2_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                    }
                    return ''
                },
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }
                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            }
        },
    }
</script>

<style scoped>

</style>